import type { IconProps } from '../types/IconProps.ts';
export const LockCheck: IconProps = {
    name: 'LockCheck',
    children: [
        `<path d="M21 13v-1a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h8M7 11V7a5 5 0 0 1 10 0v4M15 19.12l1.98 1.98q.14.12.28 0L21 17" />`,
    ]
};